import script from "./InformClientModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InformClientModal.vue?vue&type=script&setup=true&lang=js"

import "./InformClientModal.vue?vue&type=style&index=0&id=71e4d1bb&lang=scss"

const __exports__ = script;

export default __exports__